import { RecordScreenCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenCard";
import { PaymentTable } from "@/app/Payments/Components/PaymentTable";
import { PaymentStatus } from "@/gql/graphql";
import { InvoiceTable } from "@/app/Invoices/Components/InvoiceTable";
import { useContactRecord } from "@/app/Contacts/Hooks/useContactRecord";
import { GenerateInvoicesButton } from "@/app/Contacts/Components/GenerateInvoicesButton";

export function ContactInvoicesScreen() {
  const record = useContactRecord();

  return (
    <div className="space-y-12 py-6">
      <RecordScreenCard title="Invoices" buttons={<GenerateInvoicesButton />}>
        <InvoiceTable
          id="contact-invoices"
          queryVariables={{
            payeeContactId: record.id,
          }}
        />
      </RecordScreenCard>
      <RecordScreenCard title="Upcoming payments">
        <PaymentTable
          id={"contact-upcoming-payments"}
          queryVariables={{
            status: [PaymentStatus.Unpaid],
            payeeContactId: record.id,
          }}
        />
      </RecordScreenCard>
    </div>
  );
}
